<template>

    <div id="app">
        <HeaderComponent></HeaderComponent>
        <div class="page-content">
            <router-view :key="$route.params.id"/>
        </div>
        <FooterComponent></FooterComponent>
    </div>

</template>

<script>
    import Vue from 'vue';
    import HeaderComponent from './components/Header';
    import FooterComponent from './components/Footer';

    export default {
        name: 'App',
        components: {
            HeaderComponent,
            FooterComponent
        }
    };
</script>




// WEBPACK FOOTER //
// src/App.vue